export default __webpack_public_path__ + "static/media/FemaleAvt.430c723d.png";